import React, { Fragment } from 'react';
import Intro from '../Intro';
import MultipleChoice from '../MultipleChoice';
import mainConfidenceImage from '../../assets/images/confidence-ranking.gif';
import stronglyAgree from '../../assets/images/confidence-strongly-agree.svg';
import agree from '../../assets/images/confidence-agree.svg';
import neutral from '../../assets/images/confidence-neutral.svg';
import disagree from '../../assets/images/confidence-disagree.svg';
import stronglyDisagree from '../../assets/images/confidence-strongly-disagree.svg';
import Voiceover from '../Voiceover';

const data = {
  inputType: 'radio',
  options: [
    {
      label: 'Strongly agree',
      image: stronglyAgree
    },
    {
      label: 'Agree',
      image: agree
    },
    {
      label: 'Neutral',
      image: neutral
    },
    {
      label: 'Disagree',
      image: disagree
    },
    {
      label: 'Strongly disagree',
      image: stronglyDisagree
    }
  ]
};

const standardReflectFeedback = {
  success: {
    title: 'Okay.',
    body: 'Thanks for your response. Now let’s see what you’ve learned.'
  }
};

const standardPrepareFeedback = {
  success: {
    title: 'Thanks.',
    body: 'You’ll learn more about this topic as you go through the module.'
  }
};

const ConfidenceRanking = ({
  direction,
  lead,
  image,
  feedback,
  question,
  title,
  vo
}) => {
  const reflect = window.location.href.indexOf('reflect') > 0;
  const determineFeedback = () => {
    if (feedback) return feedback;
    return reflect ? standardReflectFeedback : standardPrepareFeedback;
  };

  return (
    <Fragment>
      {vo && <Voiceover {...vo} />}
      <Intro
        title={title ? title : 'What Do You Think?'}
        lead={
          lead
            ? lead
            : 'Select the image that matches how strongly you agree or disagree with the statement.'
        }
        direction={direction ? direction : 'Select the best answer.'}
        img={image ? image : mainConfidenceImage}
      />
      <MultipleChoice
        data={{
          ...data,
          question
        }}
        feedback={determineFeedback()}
      />
    </Fragment>
  );
};

export default ConfidenceRanking;



// WEBPACK FOOTER //
// ../core/src/components/ConfidenceRanking/index.js